<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-if="data!= undefined" class="rect">
      <van-row style="position: relative;">
        <van-col span="4"><img class="logoImg" :src="data.logo"></van-col>
        <van-col span="1" />
        <van-col span="19">
          <div class="pageTitle1 titleLine">{{ data.name }}</div>
          <span class="pagebody2 aboutStr">{{ data.opening_comment }}</span>
        </van-col>
        <div class="type pagebody3">{{ data.main_flags.toUpperCase() }}</div>
      </van-row>
      <van-swipe v-if="images.length > 0" ref="TopSwipe" style="margin-top:1em;" :autoplay="6000" @change="onTopSwipe">
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img :src="image.img" style="width:100%">
        </van-swipe-item>
        <div slot="indicator" class="custom-indicator swipeTop">
          <span v-for="(image, index) in images" :key="index" @click="gotoTopSwipe(index)">
            <a v-if="NowTopSwipe == index" class="mainColor"><i class="iconfont iconline" /></a>
            <a v-if="NowTopSwipe != index"><i class="iconfont iconline" /></a>
          </span>
        </div>
      </van-swipe>
      <div class="centerInfo infoBody">
        <van-row>
          <van-col span="6">国家:</van-col>
          <van-col span="18">{{ data.country_long }}</van-col>
        </van-row>
        <van-row>
          <van-col span="6">城市:</van-col>
          <van-col span="18">{{ data.city }}</van-col>
        </van-row>
        <van-row>
          <van-col span="6">地址:</van-col>
          <van-col span="18">{{ data.street }}</van-col>
        </van-row>
        <van-row>
          <van-col span="6">支持语言:</van-col>
          <van-col span="18">{{ getLanguageText(data.preferred_lang_iso3) }}(主要) {{ data.languages }}</van-col>
        </van-row>
        <br>
        <van-row v-if="data.tel != undefined && data.tel.length > 0">
          <van-col span="6">电话:</van-col>
          <van-col span="18">{{ data.tel }}</van-col>
        </van-row>
        <van-row v-if="data.web != undefined && data.web.length > 0">
          <van-col span="6">网址:</van-col>
          <van-col span="18" class="longLine">{{ data.web }}</van-col>
        </van-row>
        <van-row v-if="data.email != undefined && data.email.length > 0">
          <van-col span="6">邮箱:</van-col>
          <van-col span="18" class="longLine">{{ data.email }}</van-col>
        </van-row>
      </div>

      <div class="centerInfo infoBody">
        <van-row>
          <van-col span="12">经度:{{ data.lon }}</van-col>
          <van-col span="12" style="text-align:right">纬度:{{ data.lat }}</van-col>
        </van-row>
        <br>
        <baidu-map class="rectMap" :center="center" :zoom="zoom">
          <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT" />
          <bm-marker :position="center" :dragging="false" animation="BMAP_ANIMATION_BOUNCE" />
        </baidu-map>
        <!-- <div id="container" class="rectMap" /> -->
      </div>
    </div>
    <div v-if="data!= undefined" class="rect2">
      <div
        v-if="(data.skype != undefined && data.skype.length > 0) ||
          (data.facebook != undefined && data.facebook.length > 0) ||
          (data.twitter != undefined && data.twitter.length > 0)||
          (data.youtube != undefined && data.youtube.length > 0)
        "
        class="topLineRect"
      >
        <div class="pageTitle1 title">社交媒体</div>
        <van-row v-if="data.skype != undefined && data.skype.length > 0">
          <van-col span="2"><i class="iconfont iconskype" /></van-col>
          <van-col span="22" class="longLine">{{ data.skype }}</van-col>
        </van-row>
        <van-row v-if="data.facebook != undefined && data.facebook.length > 0">
          <van-col span="2"><i class="iconfont iconfacebook" /></van-col>
          <van-col span="22" class="longLine">{{ data.facebook }}</van-col>
        </van-row>
        <van-row v-if="data.twitter != undefined && data.twitter.length > 0">
          <van-col span="2"><i class="iconfont icontwitter" /></van-col>
          <van-col span="22" class="longLine">{{ data.twitter }}</van-col>
        </van-row>
        <van-row v-if="data.youtube != undefined && data.youtube.length > 0">
          <van-col span="2"><i class="iconfont iconyoutube" /></van-col>
          <van-col span="22" class="longLine">{{ data.youtube }}</van-col>
        </van-row>
      </div>

      <div class="topLineRect infoBody">
        <div class="pageTitle1 title">其他信息</div>
        <van-row v-if="data.fills != undefined && data.fills.length > 0">
          <van-col span="6">气体填充</van-col>
          <van-col span="18" class="longLine">{{ data.fills }}</van-col>
        </van-row>
        <van-row v-if="data.service_for != undefined && data.service_for.length > 0">
          <van-col span="6">服务</van-col>
          <van-col span="18" class="longLine">{{ data.service_for }}</van-col>
        </van-row>
        <van-row v-if="data.rental_other != undefined && data.rental_other.length > 0">
          <van-col span="6">租赁</van-col>
          <van-col span="18" class="longLine">{{ data.rental_other }}</van-col>
        </van-row>
        <van-row v-if="data.services != undefined && data.services.length > 0">
          <van-col span="6">服务</van-col>
          <van-col span="18" class="longLine">{{ data.services }}</van-col>
        </van-row>
        <van-row v-if="data.sport != undefined && data.sport.length > 0">
          <van-col span="6">项目</van-col>
          <van-col span="18" class="longLine">
            <span v-for="oneSport in data.sport.split(',')" :key="oneSport">
              {{ $t('diveCenter.sport.'+oneSport) }}
            </span>
          </van-col>
        </van-row>
        <van-row v-if="data.method_of_payment != undefined && data.method_of_payment.length > 0">
          <van-col span="6">支付方式</van-col>
          <van-col span="18" class="longLine">{{ data.method_of_payment }}</van-col>
        </van-row>
        <van-row v-if="data.misc != undefined && data.misc.length > 0">
          <van-col span="6">其他设施</van-col>
          <van-col span="18" class="longLine">{{ data.misc }}</van-col>
        </van-row>
      </div>
      <div class="topLineRect infoBody">
        <van-row>
          <van-col span="11">
            <div class="pageTitle1 title">开放时间</div>
            <van-row>
              <van-col span="8">星期一</van-col>
              <van-col span="16" class="Fontright">{{ openCloseTime(data.monday_open,data.monday_close) }}</van-col>
            </van-row>
            <van-row>
              <van-col span="8">星期二</van-col>
              <van-col span="16" class="Fontright">{{ openCloseTime(data.tuesday_open,data.tuesday_close) }}</van-col>
            </van-row>
            <van-row>
              <van-col span="8">星期三</van-col>
              <van-col span="16" class="Fontright">{{ openCloseTime(data.wednesday_open,data.wednesday_close) }}</van-col>
            </van-row>
            <van-row>
              <van-col span="8">星期四</van-col>
              <van-col span="16" class="Fontright">{{ openCloseTime(data.thursday_open,data.thursday_close) }}</van-col>
            </van-row>
            <van-row>
              <van-col span="8">星期五</van-col>
              <van-col span="16" class="Fontright">{{ openCloseTime(data.friday_open,data.friday_close) }}</van-col>
            </van-row>
            <van-row>
              <van-col span="8">星期六</van-col>
              <van-col span="16" class="Fontright">{{ openCloseTime(data.saturday_open,data.saturday_close) }}</van-col>
            </van-row>
            <van-row>
              <van-col span="8">星期天</van-col>
              <van-col span="16" class="Fontright">{{ openCloseTime(data.sunday_open,data.sunday_close) }}</van-col>
            </van-row>
          </van-col>
          <van-col span="2" />
          <van-col span="11">
            <div class="pageTitle1 title">休息时段</div>
            <van-row>
              <van-col span="8">午餐时间</van-col>
              <van-col span="16" class="Fontright">{{ openCloseTime(data.lunch_from,data.lunch_till) }}</van-col>
            </van-row>
          </van-col>
        </van-row>
      </div>

      <div class="topLineRect infoBody">
        <div class="pageTitle1 title">中心课程</div>
        <!-- {{ data.dc_courses }} -->
        <div class="courseTable infoBody">
          <div v-for="(item, index) in courseList" :key="index" class="courseRect" @click="CourseInfo(item.description)">
            <van-row>
              <van-col span="10"> <img :src="item.img"></van-col>
              <van-col span="14" class="longLine">{{ item.title }}</van-col>
            </van-row>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="showCourseInfo" class="showCourse">{{ showCourseBody }}</van-popup>
  </div>

</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, getCoursesList, getLanguageText } from '@/utils/base'
import { Popup, Swipe, SwipeItem } from 'vant'
export default {
  name: 'Globaldivecenter',
  components: {
    [Popup.name]: Popup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    TopBar
  },
  data() {
    return {
      title: '潜水中心',
      backurl: '/store/globaldivecenterList',
      id: undefined,
      data: undefined,
      NowTopSwipe: 0,
      images: [],
      map: undefined,
      courseList: [],
      showCourseInfo: false,
      showCourseBody: '',
      center: { lng: 0, lat: 0 },
      zoom: 6
    }
  },
  created() {
    initPage(true)
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.id = this.$route.params.id

    request({
      url: '/Store/getDiveCenterById',
      method: 'post',
      params: { id: this.id }
    }).then(response => {
      if (!response.success) {
        this.error = true
        return
      }
      console.log(response)
      this.data = response.data
      this.title = this.data.name
      this.images = []
      // this.data.skype = 'skype'
      // this.data.facebook = 'facebook'
      // this.data.twitter = 'twitter'
      // this.data.youtube = 'youtube'
      // 课程
      getCoursesList(courses => {
        this.courseList = []
        this.data.dc_courses.split(',').forEach(item => {
          var course = courses.find((value, index, array) => value.short === item)
          if (course !== undefined) {
            this.courseList.push({
              img: course.image,
              title: course.program,
              id: course.short,
              description: course.description
            })
          } else {
            console.log(item)
            console.log(course)
          }
        })
      })
      this.center.lng = this.data.lon
      this.center.lat = this.data.lat
      if (this.data.image1 !== undefined && this.data.image1 !== '' && !this.data.image1.endsWith('/')) {
        this.images.push({
          img: this.data.image1
        })
      }
      if (this.data.image2 !== undefined && this.data.image2 !== '' && !this.data.image2.endsWith('/')) {
        this.images.push({
          img: this.data.image2
        })
      }
      if (this.data.image3 !== undefined && this.data.image3 !== '' && !this.data.image3.endsWith('/')) {
        this.images.push({
          img: this.data.image3
        })
      }
    })
  },
  methods: {
    getLanguageText,
    CourseInfo(description) {
      this.showCourseBody = description
      if (description !== undefined && description !== '' && description !== null) {
        this.showCourseInfo = true
      }
    },
    openCloseTime(open, close) {
      var result = ''
      if (open === undefined || close === '') {
        result = 'n/a'
      } else {
        result = open
      }
      result += ' ~ '
      if (close === undefined || close === '') {
        result += 'n/a'
      } else {
        result += close
      }
      return result
    },
    onTopSwipe(index) {
      this.NowTopSwipe = index
    },
    gotoTopSwipe(index) {
      this.NowTopSwipe = index
      this.$refs.TopSwipe.swipeTo(index)
    }
  }
}
</script>
<style scoped>

.rect{
    padding: 1em;
    /* background-color: #F1F1F1; */
}
.rect2{
  border-top: 1px solid #cacaca;
    padding: 0.1em 1em 1em 1em;
    background-color: #F1F1F1;
}
.logoImg{
    width: 100%;
}
.titleLine{
   padding-top: 1.5em;
   line-height: 1.4em;
  /* padding-right: 5em; */
}
.type{
  position: absolute;
  top: 0;
  right: 0;
  color: #fff;
  background-color: #E32119;
  padding: 0 0.2em;
}
.Fontright{
  text-align: right;
}
.centerInfo{
  margin-top:1em;
  padding-top:1em;
  border-top:1px solid #060202;
}
.infoBody{
  font-weight: 700;
  font-size: 0.9em;
}
.longLine{
  word-break:break-all;
}
.rectMap{
  width: 100%;
  height: 17em;
}
.topLineRect{
  border-top: 3px solid #000;
  margin-top: 1em;
  background-color: #fff;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  padding: 1em;
}
.topLineRect .title{
  padding-bottom: 0.5em;
  margin-bottom: 0.3em;
  border-bottom: 2px solid #000;
}
.courseTable
{
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
}
.courseTable .courseRect{
  width: 100%;
  margin-top: 0.5em;
}
.courseTable .courseRect img{
  width:90%;
}
.showCourse{
 width: 80%;
  padding: 1em;
}
</style>
